export const superfundBoundary = {
  type: "FeatureCollection",
  name: "gowanus_canal_superfund",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {},
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.998568555999952, 40.671591751000051],
            [-73.998825464999982, 40.671507315000042],
            [-74.000264303999984, 40.668740955000032],
            [-74.000993983999933, 40.668994221000048],
            [-74.001301439999963, 40.668363917000079],
            [-74.002136963999988, 40.66855520200005],
            [-74.002782323999952, 40.667455837000034],
            [-74.002991880999957, 40.667264719000059],
            [-74.003100765999989, 40.667310301000043],
            [-74.003531925999937, 40.667405765000069],
            [-74.003530090999959, 40.667324970000038],
            [-74.002809802999934, 40.666303824000067],
            [-74.002811636999979, 40.666384618000052],
            [-74.002646065999954, 40.666581704000066],
            [-74.002126189999956, 40.666898563000075],
            [-74.001564835999943, 40.666761575000066],
            [-74.001208813999938, 40.667015073000073],
            [-74.001354825999954, 40.667171159000077],
            [-74.000479446999975, 40.667586521000032],
            [-74.000369939999985, 40.667486908000058],
            [-74.00012961699997, 40.66753041100003],
            [-73.99983293799994, 40.667453410000064],
            [-73.99939823699998, 40.668003762000069],
            [-73.999038556999949, 40.668221752000079],
            [-73.99888855599994, 40.668401752000079],
            [-73.999000366999951, 40.668575376000035],
            [-73.998978136999938, 40.66877770900004],
            [-73.998765987999946, 40.66888146000008],
            [-73.998769189999962, 40.669022852000069],
            [-73.998716952999985, 40.669084138000073],
            [-73.998826459999975, 40.669183753000027],
            [-73.998643858999969, 40.669408354000041],
            [-73.998535266999966, 40.669349135000061],
            [-73.998403528999972, 40.669451854000044],
            [-73.998782915999982, 40.669628817000046],
            [-73.998464641999988, 40.670966425000074],
            [-73.998438556999986, 40.671391751000044],
            [-73.997278556999959, 40.672771751000028],
            [-73.996838556999933, 40.672521751000033],
            [-73.996718556999951, 40.672641751000072],
            [-73.997208556999965, 40.67290175100004],
            [-73.995478556999956, 40.674981751000075],
            [-73.994088557999987, 40.674341751000043],
            [-73.993908557999987, 40.67454175000006],
            [-73.995238556999936, 40.675221751000038],
            [-73.99468855799995, 40.675681750000081],
            [-73.994448557999988, 40.675731750000068],
            [-73.992308557999934, 40.674701751000043],
            [-73.992138557999965, 40.674891750000029],
            [-73.994048557999974, 40.675911750000068],
            [-73.993638557999986, 40.675981751000052],
            [-73.992718558999968, 40.675891750000062],
            [-73.99074855899994, 40.675541751000026],
            [-73.990448557999969, 40.674861751000037],
            [-73.988968558999943, 40.674171750000028],
            [-73.988778558999968, 40.674351750000028],
            [-73.990258558999983, 40.675041751000037],
            [-73.990428557999962, 40.675621750000062],
            [-73.989038558999937, 40.677251750000039],
            [-73.989028558999962, 40.678111750000028],
            [-73.986678559999973, 40.681621749000044],
            [-73.986968558999934, 40.681741749000025],
            [-73.988538558999949, 40.679531749000034],
            [-73.988825806999955, 40.679057791000048],
            [-73.989268559999971, 40.678381750000028],
            [-73.989338558999975, 40.678241750000041],
            [-73.989428558999975, 40.677341750000039],
            [-73.99065855799995, 40.67579175000003],
            [-73.992811966999966, 40.676103457000067],
            [-73.993128557999967, 40.676151751000077],
            [-73.993848557999968, 40.676151750000031],
            [-73.994188556999973, 40.67612175000005],
            [-73.994518557999982, 40.676051751000045],
            [-73.994828557999938, 40.67594175000005],
            [-73.995058557999982, 40.675801751000051],
            [-73.995478556999956, 40.675451751000026],
            [-73.995898557999965, 40.674961751000069],
            [-73.997659272999954, 40.672855328000026],
            [-73.998568555999952, 40.671591751000051],
          ],
        ],
      },
    },
  ],
};

export const sewerOverflows = {
  type: "FeatureCollection",
  name: "gowanus_sewer_overflows",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.988608, 40.678766] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.986846, 40.681694] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.986912, 40.681317] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-74.000313, 40.667487] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.990946, 40.675536] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.998917, 40.671423] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.987325, 40.680677] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.989013, 40.678044] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.992566, 40.676106] },
    },
    {
      type: "Feature",
      properties: {},
      geometry: { type: "Point", coordinates: [-73.987739, 40.680033] },
    },
  ],
};

export const retentionTanks = {
  type: "FeatureCollection",
  name: "gowanus_retention_tanks",
  crs: {
    type: "name",
    properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
  },
  features: [
    {
      type: "Feature",
      properties: { id: 0 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-73.990835033287212, 40.675528235768169],
              [-73.991556269444104, 40.674643385490548],
              [-73.994285653332042, 40.675919711234727],
              [-73.993005812700659, 40.675908985910105],
              [-73.990835033287212, 40.675528235768169],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { id: 1 },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-73.985705111468846, 40.681631476895085],
              [-73.986960214005791, 40.679797986876906],
              [-73.987719006329044, 40.680090019550377],
              [-73.986477990399493, 40.681917015883819],
              [-73.985705111468846, 40.681631476895085],
            ],
          ],
        ],
      },
    },
  ],
};

export const newHousing = {
  type: "FeatureCollection",
  name: "gowanus_new_housing",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {},
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-73.984998592035112, 40.681289983040735],
              [-73.985164333288907, 40.681045456160753],
              [-73.98508094900572, 40.681012853053524],
              [-73.985248917425295, 40.680765034956934],
              [-73.985332458898114, 40.680797408400345],
              [-73.985648939775118, 40.680920047268259],
              [-73.985976337730278, 40.681046917249567],
              [-73.985806286575738, 40.681296456033806],
              [-73.985479021700627, 40.681168497833852],
              [-73.985350100056976, 40.681118090366745],
              [-73.985185259405839, 40.681362795911006],
              [-73.984998592035112, 40.681289983040735],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {},
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-73.985147037306533, 40.678953046182947],
              [-73.985477745351616, 40.678459523284836],
              [-73.986084702700211, 40.678695850576609],
              [-73.986219764571956, 40.678748438096697],
              [-73.986059342547023, 40.678987828773309],
              [-73.986017330211411, 40.678971472122633],
              [-73.985924282625547, 40.678935242907073],
              [-73.985882094215683, 40.678918815909945],
              [-73.985812466196407, 40.678891705433827],
              [-73.985744455016231, 40.678865225416509],
              [-73.985575234822377, 40.679117769120126],
              [-73.985147037306533, 40.678953046182947],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {},
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-73.988286189939217, 40.677933554889293],
              [-73.988990390993422, 40.678208581002401],
              [-73.988988210625891, 40.678247026483909],
              [-73.988926368060362, 40.678348772874052],
              [-73.988626733834707, 40.678791195708108],
              [-73.988617033502365, 40.678805383672923],
              [-73.988597639610845, 40.678832003059263],
              [-73.988441154322416, 40.679056097826631],
              [-73.988426883357945, 40.679076536186116],
              [-73.988375146370757, 40.679153182580663],
              [-73.988263927672023, 40.679322160376643],
              [-73.987536497748067, 40.679039535184764],
              [-73.988286189939217, 40.677933554889293],
            ],
          ],
        ],
      },
    },
  ],
};
